export const isTspVehicle = (dataSource?: string) => dataSource?.toLowerCase() === 'tsp';
